import { PublicationFeaturedDto } from '@app/data/dtos/multimedia/publication/publication-featured.dto';
import { PublicationFeatured } from '@app/entities/models/multimedia/publication-featured.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapPublicationFeatured: MapFromFn<PublicationFeaturedDto, PublicationFeatured> = (value) =>
  Builder.forModel(PublicationFeatured)
    .id(value?.id)
    .thumbnail(value?.thumbnail)
    .slug(value?.slug)
    .translationKey(value?.translation_key)
    .build();
